import React from 'react';

const MySkills = () => {
    return (
        <div>
            <section className=" text-black font-normal">
                <div className="container flex flex-col justify-center p-12 mx-auto sm:py-16 lg:py-24 lg:flex-row lg:justify-around">
                    <div className="flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left">
                        <h1 className="text-3xl font-semibold font-serif leading-none sm:text-5xl text-black">My Special Skills Here!!<br />

                        </h1>



                        <div className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">


                        </div>
                    </div>
                    <div className="flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128">
                        <div>
                            <div>
                                <small>HTML & CSS</small> <br />
                                <progress className="progress w-60" value="95" max="100"></progress> <br />
                                <small>JavaScript</small> <br />
                                <progress className="progress w-60" value="85" max="100"></progress> <br />
                                <small>Node Js</small> <br />
                                <progress className="progress w-60" value="60" max="100"></progress> <br />
                                <small>React</small> <br />
                                <progress className="progress w-60" value="70" max="100"></progress> <br />
                                <small>Teamwork</small> <br />
                                <progress className="progress w-60" value="90" max="100"></progress> <br />
                                <small>Flexibility</small> <br />
                                <progress className="progress w-60" value="80" max="100"></progress> <br />
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default MySkills;